import { render, staticRenderFns } from "./Tambah.vue?vue&type=template&id=2323f41e&scoped=true&"
import script from "./Tambah.vue?vue&type=script&lang=js&"
export * from "./Tambah.vue?vue&type=script&lang=js&"
import style0 from "./Tambah.vue?vue&type=style&index=0&id=2323f41e&scoped=true&lang=css&"
import style1 from "./Tambah.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./Tambah.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2323f41e",
  null
  
)

export default component.exports